import React from 'react';
//import smoothscroll from 'smoothscroll-polyfill';



class Term extends React.Component{

  constructor(props) {
    super(props);
    this.ref = React.createRef()

    // kick off the polyfill to enable smooth scrolling in Chrome
//    smoothscroll.polyfill();
  }

  checkTermMatch = () => {
      console.log('here');
    let isSelected = false;
    let currentTerm = this.props.term.trim();
    let selectedTerm = this.props.selectedTerm.trim();

    if(selectedTerm === currentTerm){
      isSelected = true;
    }

    return isSelected;
  }

  componentDidMount() {
    if (this.checkTermMatch()) {
      this.ref.current.scrollIntoView({
//        Not working in Chrome
//        behavior: 'smooth',
        block: 'center',
        inline: 'center',
      });
    }
  }

  filterTerms = () => {
    let allTerms = this.props.terms;
    let thisTerm = allTerms.filter(tm => tm[ 'Term' ] === this.props.term);
//      console.log('thisTerms: ', thisTerm);
    return thisTerm;
  }

  _render() {

    return(
      <div>Term Test</div>
    )
  }

  render(){

    let thisTerm = this.filterTerms();
    thisTerm = thisTerm[0];

    let termClass = 'term ';
    if (this.checkTermMatch()){
      termClass = 'term active';
    }

    return(
      <li ref={this.ref} className={termClass}>
        <p className="type">{thisTerm.Type}</p>
        <p className="title">{thisTerm.Term}</p>
        <p className="explanation">{thisTerm.Explanation}</p>
      </li>
    )
  }
}
export default Term;



// WEBPACK FOOTER //
// ./src/components/Term/term.js